import React, { useEffect, useState } from "react";
import { FaPen } from "react-icons/fa6";
import { StripeUpdatePayment } from "../../../components/stripeUpdatePayment";
import Swal from "sweetalert2";
import { axiosWithToken, functionBaseUrl } from "../../../common/firebase";
import moment from "moment";
import { listOfSubscriptionNames, SUBSCRIPTION_ADDONS } from "../../../common/envConfig";
import Divider from "../../../components/shared/Divider/Divider";
import { RiVisaLine, RiMastercardLine } from "react-icons/ri";
import { stripeService } from "../../../components/stripeSubscription/services/stripe";
import { useUserSubscriptionAddons } from "../../../hooks/useUserSubscriptionAddons";

export const AccountDetailsPlan = ({
  onViewChange,
  status,
  subscriptionType,
  secondarySubType,
  plan,
  autoRenewal,
  endDate,
  endDateInMS,
  type,
  platform,
  email,
  transactionId,
  userId,
  subscriptionId,
  startDate,
  amount,
  partnerSubData,
}) => {
  const { subscriptionAddons } = useUserSubscriptionAddons();

  const [showStripe, setShowStripe] = useState(false);
  const [cardData, setCardData] = useState({ lastFour: "", brand: "" });

  useEffect(() => {
    (async () => {
      const res = await stripeService.getStripePaymentMethods({ email });
      if (res?.data?.paymentMethods?.data?.length > 0) {
        setCardData({
          brand: res.data.paymentMethods.data[0].card.brand.toUpperCase(),
          lastFour: res.data.paymentMethods.data[0].card.last4,
        });
      }
    })();
  }, [email]);

  const handlePlanChange = async (productId) => {
    if (platform === "Apple" || platform === "Google") {
      await Swal.fire({
        title:
          '<p style="font-size:70%;">To cancel your subscription, please go to the platform that you originally subscribed from</p>',
        icon: "warning",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        customClass: {
          container: "my-swal",
        },
      });
      return false;
    }
    if (
      productId?.includes("foresight")
        ? partnerSubData?.foresight?.autoRenewal
        : autoRenewal
    ) {
      await Swal.fire({
        title:
          '<p style="font-size:70%;">Are you sure you want to cancel your subscription?</p>',
        icon: "warning",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "red",
        allowOutsideClick: false,
        customClass: {
          container: "my-swal",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (productId?.includes("foresight")) {
            await axiosWithToken(
              functionBaseUrl + "/api/pausePartnerSub/" + userId,
              {
                method: "POST",
              }
            )
              .then(async () => {
                await Swal.fire({
                  title:
                    '<p style="font-size:70%;">Subscription successfully canceled</p>',
                  icon: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                  timer: 2000,
                  customClass: {
                    container: "my-swal",
                  },
                }).then(() => {
                  window.location.reload();
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            await axiosWithToken(
              functionBaseUrl +
                (platform === "Elavon"
                  ? "/api/cancelElavonTxn/"
                  : "/api/pauseStripeSub/") +
                userId,
              {
                method: "POST",
              }
            )
              .then(async () => {
                await Swal.fire({
                  title:
                    '<p style="font-size:70%;">Subscription successfully canceled</p>',
                  icon: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                  timer: 2000,
                  customClass: {
                    container: "my-swal",
                  },
                }).then(() => {
                  window.location.reload();
                });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          return false;
        }
      });
    } else {
      await Swal.fire({
        title:
          '<p style="font-size:70%;">Are you sure you want to resume your subscription?</p>',
        icon: "warning",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "red",
        allowOutsideClick: false,
        customClass: {
          container: "my-swal",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (productId?.includes("foresight")) {
            await axiosWithToken(
              functionBaseUrl + "/api/resumePartnerSub/" + userId,
              {
                method: "POST",
              }
            )
              .then(async () => {
                await Swal.fire({
                  title:
                    '<p style="font-size:70%;">Subscription successfully canceled</p>',
                  icon: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                  timer: 2000,
                  customClass: {
                    container: "my-swal",
                  },
                }).then(() => {
                  window.location.reload();
                });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            if (platform === "Elavon") {
              await axiosWithToken(functionBaseUrl + "/api/activateElavonTxn", {
                method: "POST",
                data: {
                  ssl_recurring_id: transactionId,
                  ssl_billing_cycle: amount > 200 ? "ANNUALLY" : "MONTHLY",
                  ssl_next_payment_date: endDate,
                },
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then(async (response) => {
                  await axiosWithToken(
                    functionBaseUrl + "/api/subscription/" + subscriptionId,
                    {
                      method: "patch",
                      data: { autoRenewal: true },
                    }
                  )
                    .then(() => {
                      Swal.fire({
                        title:
                          '<p style="font-size:70%;">Subscription successfully activated</p>',
                        confirmButtonText: "Ok",
                        allowOutsideClick: false,
                        icon: "success",
                        timer: 2000,
                        customClass: {
                          container: "my-swal",
                        },
                      }).then(() => {
                        window.location.reload();
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire(
                    '<p style="font-size:70%;">There was an error activating your subscription, please try again</p>'
                  );
                });
            }
            if (platform === "Stripe") {
              await axiosWithToken(
                functionBaseUrl + "/api/resumeStripeSub/" + userId,
                {
                  method: "POST",
                }
              )
                .then(async () => {
                  await Swal.fire({
                    title:
                      '<p style="font-size:70%;">Subscription successfully resumed</p>',
                    icon: "success",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    customClass: {
                      container: "my-swal",
                    },
                  }).then(() => {
                    window.location.reload();
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        } else {
          return false;
        }
      });
    }
  };

  return (
    <>
      <div className="p-6 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
        <div className="text-gray600 font-semibold text-sm">
          Your Membership
        </div>
        <div className="mt-2 text-gray900 font-semibold text-xl">{type}</div>

        {!subscriptionType.includes("free") && (
          <>
            <Divider className="my-6" color="gray200" type="horizontal" />

            <div className="flex flex-col gap-4">
              <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                <div className="text-black font-bold text-sm text-nowrap">
                  Status
                </div>
                <div className="text-black text-sm w-full max-w-[620px]">
                  {status ? "Active" : "Expired"}
                </div>
              </div>
              <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                <div className="text-black font-bold text-sm text-nowrap">
                  Current plan
                </div>
                <div className="text-black text-sm w-full max-w-[620px]">
                  {plan}
                </div>
              </div>
              {subscriptionAddons && subscriptionAddons?.length > 0 && (
                <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                  <div className="text-black font-bold text-sm text-nowrap">
                    Subscription addons
                  </div>
                  <div className="text-black text-sm w-full max-w-[620px]">
                    {subscriptionAddons?.map((a, index) => (
                      <>
                        <span key={a.addonType}>
                          {SUBSCRIPTION_ADDONS[a.addonType]?.name}
                        </span>
                        {index !== subscriptionAddons?.length - 1 && ", "}
                      </>
                    ))}
                  </div>
                </div>
              )}
              {secondarySubType && (
                <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                  <div className="text-black font-bold text-sm text-nowrap">
                    Secondary plan
                  </div>
                  <div className="text-black text-sm w-full max-w-[620px]">
                    {secondarySubType}
                  </div>
                </div>
              )}
              <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                <div className="text-black font-bold text-sm text-nowrap">
                  Auto-renewal
                </div>
                <div className="text-black text-sm w-full max-w-[620px]">
                  {autoRenewal ? "On" : "Off"}
                </div>
              </div>
              <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                <div className="text-black font-bold text-sm text-nowrap">
                  End date
                </div>
                <div className="text-black text-sm w-full max-w-[620px]">
                  {endDate}
                </div>
              </div>
              {cardData.brand && cardData.lastFour && (
                <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                  <div className="text-black font-bold text-sm text-nowrap">
                    Payment
                  </div>
                  <div className="text-black text-sm w-full max-w-[620px] flex items-center gap-5">
                    <div className="flex items-center gap-1">
                      {cardData.brand === "VISA" ? (
                        <RiVisaLine className="size-7" />
                      ) : cardData.brand === "MASTERCARD" ? (
                        <RiMastercardLine className="size-7" />
                      ) : (
                        cardData.brand
                      )}{" "}
                      •••• •••• •••• {cardData.lastFour}
                    </div>

                    <FaPen
                      className="cursor-pointer size-4 text-grayTrue500"
                      onClick={() => setShowStripe(true)}
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        <div className="flex flex-col md:flex-row md:items-center gap-4 mt-6">
          <button
            onClick={() => onViewChange("plan-details")}
            className={`w-fit min-h-11 h-11 rounded-full font-semibold text-sm ${
              subscriptionType.includes("free") ? "btnPrimary500" : "btnGray100"
            }`}
          >
            {subscriptionType.includes("free")
              ? "Upgrade"
              : "Manage subscription"}
          </button>

          {transactionId &&
            endDateInMS &&
            subscriptionType &&
            !subscriptionType.includes("enterprise") &&
            !subscriptionType.includes("studio") && (
              <button
                onClick={() => handlePlanChange(subscriptionType)}
                className={`w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnGray100`}
              >
                {autoRenewal ? "Cancel plan" : "Resume plan"}
              </button>
            )}
        </div>
        {showStripe ? <StripeUpdatePayment subscriptionId={plan} /> : <></>}
      </div>

      {/* {subscriptionType &&
        !subscriptionType?.includes("free") &&
        partnerSubData && (
          <div className="mt-6 p-6 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
            <div className="text-gray600 font-semibold text-sm">Extra</div>
            <div className="text-4xl text-black mt-4">
              Foresight Integration
            </div>
            {partnerSubData?.foresight && (
              <>
                <Divider className="my-6" color="gray200" type="horizontal"/>

                <div className="flex flex-col gap-4">
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Status
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {partnerSubData?.foresight?.endDate > Date.now()
                        ? "Active"
                        : "Expired"}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Current plan
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {
                        listOfSubscriptionNames[
                          partnerSubData?.foresight?.productId
                        ]
                      }
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Auto-renewal
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {partnerSubData?.foresight?.autoRenewal ? "On" : "Off"}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      End date
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {moment(+partnerSubData?.foresight?.endDate).format(
                        "MM-DD-YYYY"
                      )}
                    </div>
                  </div>
                  {cardData.brand &&
                    cardData.lastFour &&
                    partnerSubData?.foresight?.transactionId && (
                      <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                        <div className="text-black font-bold text-sm text-nowrap">
                          Payment
                        </div>
                        <div className="text-black text-sm w-full max-w-[620px] flex items-center gap-5">
                          <div className="flex items-center gap-1">
                            {cardData.brand === "VISA" ? (
                              <RiVisaLine className="size-7" />
                            ) : cardData.brand === "MASTERCARD" ? (
                              <RiMastercardLine className="size-7" />
                            ) : (
                              cardData.brand
                            )}{" "}
                            •••• •••• •••• {cardData.lastFour}
                          </div>

                          <FaPen
                            className="cursor-pointer size-4 text-grayTrue500"
                            onClick={() => setShowStripe(true)}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </>
            )}

            <div className="flex flex-col md:flex-row md:items-center gap-4 mt-6">
              {(!partnerSubData?.foresight ||
                partnerSubData?.foresight?.endDate < Date.now()) && (
                <button
                  onClick={() => onViewChange("foresight-payment")}
                  className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500"
                >
                  Purchase
                </button>
              )}

              {partnerSubData?.foresight?.transactionId && (
                <button
                  onClick={() =>
                    handlePlanChange(partnerSubData?.foresight?.productId)
                  }
                  className="w-fit min-h-11 h-11 rounded-full font-semibold text-sm btnGray100"
                >
                  {partnerSubData?.foresight?.autoRenewal
                    ? "Cancel plan"
                    : "Resume plan"}
                </button>
              )}
            </div>

            {partnerSubData?.wwg && (
              <>
                <div className="text-4xl text-black mt-4">World Wide Golf</div>

                <Divider className="my-6" color="gray200" />

                <div className="flex flex-col gap-4">
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Status
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {partnerSubData?.wwg?.endDate > Date.now()
                        ? "Active"
                        : "Expired"}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Current plan
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {listOfSubscriptionNames[partnerSubData?.wwg?.productId]}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      End date
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {moment(+partnerSubData?.wwg?.endDate).format(
                        "MM-DD-YYYY"
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {partnerSubData?.lag && (
              <>
                <div className="text-4xl text-black mt-4">LA Golf Studio</div>

                <Divider className="my-6" color="gray200" type="horizontal"/>

                <div className="flex flex-col gap-4">
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Status
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {partnerSubData?.lag?.endDate > Date.now()
                        ? "Active"
                        : "Expired"}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      Current plan
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {listOfSubscriptionNames[partnerSubData?.lag?.productId]}
                    </div>
                  </div>
                  <div className="gap-2 flex flex-col md:flex-row md:justify-between w-full max-w-[1000px]">
                    <div className="text-black font-bold text-sm text-nowrap">
                      End date
                    </div>
                    <div className="text-black text-sm w-full max-w-[620px]">
                      {moment(+partnerSubData?.lag?.endDate).format(
                        "MM-DD-YYYY"
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )} */}
    </>
  );
};
